module.exports = __webpack_public_path__ + "static/media/time-manager.3e97c3c8.svg";